import { render, staticRenderFns } from "./NewsBoard.vue?vue&type=template&id=2e565bd8&scoped=true&"
import script from "./NewsBoard.vue?vue&type=script&lang=ts&"
export * from "./NewsBoard.vue?vue&type=script&lang=ts&"
import style0 from "./NewsBoard.vue?vue&type=style&index=0&id=2e565bd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e565bd8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
